import React from 'react';

import classNames from '@app/ui/sports-components/utils/classNames';

interface ModalProps {
    className?: string;
    children?: React.ReactNode;
}
// TODO: Migrate to functional component
class Modal extends React.Component<ModalProps> {
    componentDidMount() {
        document.body.classList.add('-noscroll');
    }

    componentWillUnmount() {
        document.body.classList.remove('-noscroll');
    }

    render() {
        const { className, ...otherProps } = this.props;
        const modalClases = classNames(
            'gds-modal',
            'gds-layout__column--md-12',
            className,
        );

        return (
            <div
                className="gds-modal__overlay gds-modal--shown gds-flex gds-flex--direction-col gds-flex--justify-center gds-flex--align-center"
                style={{ zIndex: 9999 }}
            >
                <div className={modalClases} {...otherProps}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default Modal;
